const getVersion = ({version_major, version_minor, version_revision}) =>
  `${version_major}.${version_minor}.${version_revision}`;

export default getVersion;
